import { useEffect, useState } from "react";
import { UrlApi } from "../../../../../../../../services/apirest";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import ReciboDetalleView from "./ReciboDetalleView";
import { getData } from "../../../../../../../../services/library";
import moment from "moment";

const ReciboDetalleContainer = ({
  open,
  onClose,
  reciboId,
  data: previewData,
  onConfirm,
  clienteData,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const [provincias, setProvincias] = useState([]);
  const [tiposDePago, setTiposDePago] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [marcasTarjeta, setMarcasTarjeta] = useState([]);
  const [facturas, setFacturas] = useState([]); //En realidad son solo nombres de comprobantes y numero de comprobante de envasado !== 1
  const [valorMaximoRedondeo, setValorMaximoRedondeo] = useState(null);

  // console.log("DATA DEL CLIENTE: ", clienteData);

  const mode = reciboId ? "View" : "Preview";

  // console.log(
  //   mode === "View" ? `VIEW ID: ${reciboId}` : "PREVIEW DATA:",
  //   previewData,
  // );
  useEffect(() => {
    getData(
      `/ctacte/recibos/comprobantes/facturas/${clienteData.id}/${clienteData.id_tipocliente === 3 ? 1 : 0}`,
      setFacturas,
    );
  }, [clienteData]);

  useEffect(() => {
    getData("/bancos", setBancos);
    getData("/ctacte/recibos/tipos/pago", setTiposDePago);
    getData("/ctacte/recibos/marcas/tarjeta", setMarcasTarjeta);
    getData("/provincias", setProvincias);
    getData("/ctacte/recibos/maximos/redondeo", setValorMaximoRedondeo);
  }, []);

  const findBancos = (id) => {
    return bancos.find((b) => b.id === id)?.nombre;
  };

  const findTiposDePago = (id) => {
    return tiposDePago.find((t) => t.id === id)?.valor;
  };

  const findMarca = (id) => {
    return marcasTarjeta.find((m) => m.id === id)?.marca;
  };

  const findNroComprobante = (id) => {
    return facturas.find((f) => f.id_factura === id)?.nro_comprobante;
  };

  const findNombreComprobante = (id) => {
    return facturas.find((f) => f.id_factura === id)?.comprobante;
  };

  const findNombreProvincias = (id) => {
    return provincias.find((p) => p.id === id)?.provincia;
  };
  useEffect(() => {
    if (open && mode === "View") {
      const fetchRecibo = async () => {
        setLoading(true);
        setError(null);

        try {
          const response = await fetch(`${UrlApi}/ctacte/recibos/${reciboId}`);

          if (!response.ok) {
            throw new Error("Error al cargar el recibo");
          }

          const data = await response.json();
          setData(data);
        } catch (err) {
          console.error("Error al cargar recibo:", err);
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };

      fetchRecibo();
    }
  }, [open, reciboId, mode]);

  const handleSubmit = async () => {
    if (mode === "Preview" && onConfirm) {
      try {
        setSubmitting(true);
        await onConfirm(previewData);
        onClose();
      } catch (e) {
        setError(e.message);
      } finally {
        setSubmitting(false);
      }
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
    }).format(amount || 0);
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("DD/MM/YYYY");
  };

  const formatNumeroRecibo = (reciboData) => {
    if (!reciboData?.recibo) return "-";
    const { pto_vta, numero_recibo } = reciboData.recibo;
    return `${pto_vta.padStart(4, "0")}-${numero_recibo.padStart(8, "0")}`;
  };

  const normalizePreviewToBackend = (data) => {
    if (!data) return null;

    const { recibo, retenciones, instrumentos, tarjetas, imputaciones } = data;

    const efectivo = Number(recibo.efectivo || 0);

    const redondeo = Number(recibo.redondeo || 0);

    const totalInstrumentos =
      instrumentos?.reduce((acc, i) => acc + Number(i.importe || 0), 0) || 0;

    const totalTarjetas =
      tarjetas?.reduce((acc, t) => acc + Number(t.importe || 0), 0) || 0;

    const totalRetenciones =
      Number(retenciones?.suss || 0) +
      Number(retenciones?.iva || 0) +
      Number(retenciones?.ganancias || 0) +
      Number(retenciones?.drei || 0) +
      (retenciones?.iibb?.reduce((acc, r) => acc + Number(r.importe || 0), 0) ||
        0);

    const total =
      efectivo + totalInstrumentos + totalTarjetas + totalRetenciones;

    return {
      comprobante: "Recibo",

      recibo: {
        id: null, // preview no tiene
        cuit: recibo.cuit || "",
        fecha_de_pago: recibo.fecha_de_pago,
        pto_vta: recibo.pto_vta || "",
        numero_recibo: recibo.numero_recibo || "",
        es_recibo_electronico: recibo.es_recibo_electronico ? 1 : 0,
        efectivo: recibo.efectivo,
        redondeo: recibo.redondeo,
        total,
      },

      retenciones: retenciones
        ? {
            id: null,
            recibo_id: null,
            suss: Number(retenciones.suss || 0),
            iva: Number(retenciones.iva || 0),
            ganancias: Number(retenciones.ganancias || 0),
            drei: Number(retenciones.drei || 0),
            iibb:
              retenciones.iibb?.map((r, i) => ({
                id: i,
                retencion_id: null,
                provincia_id: r.provincia_id,
                provincia: findNombreProvincias(r.provincia_id) || "",
                importe: Number(r.importe || 0),
              })) || [],
          }
        : {
            suss: 0,
            iva: 0,
            ganancias: 0,
            drei: 0,
            iibb: [],
          },

      tarjetas:
        tarjetas?.map((t, i) => ({
          id: i,
          recibo_id: null,
          valor: findTiposDePago(t.tipo) || "",
          banco_id: t.banco_id || null,
          marca_id: t.marca_id || null,
          marca: findMarca(t.marca_id) || "",
          lote: t.lote || "",
          cupon: t.cupon || "",
          ultimos4: t.ultimos4 || "",
          importe: Number(t.importe || 0),
          banco_nombre: findBancos(t.banco_id) || "",
        })) || [],

      instrumentos_bancarios:
        instrumentos?.map((inst, i) => ({
          id: i,
          recibo_id: null,
          tipo: findTiposDePago(inst.tipo) || null,
          banco_id: inst.banco_id || null,
          nro_comprobante: inst.nro_comprobante || "",
          fecha: inst.fecha || "",
          fecha_de_pago: inst.fecha_de_pago || "",
          importe: Number(inst.importe || 0),
          cuit_firma: inst.cuit_firma || "",
          banco_nombre: findBancos(inst.banco_id) || "",
          forma_de_pago: findTiposDePago(inst.tipo) || "",
        })) || [],

      imputaciones:
        imputaciones?.map((imp, i) => ({
          id: i,
          importe: Number(imp.importe || 0),
          user: imp.user || null,
          fecha_imputacion: imp.fecha_imputacion || new Date().toISOString(),
          comprobante: findNombreComprobante(imp.id_factura) || "",
          nro_factura: findNroComprobante(imp.id_factura) || "",
        })) || [],

      totales: {
        efectivo,
        redondeo,
        total_instrumentos: totalInstrumentos,
        total_tarjeta: totalTarjetas,
        total_retenciones: totalRetenciones,
        total,
      },
    };
  };

  const rawData = mode === "Preview" ? previewData : data;

  const finalData =
    mode === "Preview" ? normalizePreviewToBackend(rawData) : rawData;
  if (!rawData) {
    return null;
  }

  if (loading) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogContent>
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Cargando recibo...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  if (submitting) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogContent>
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Creando recibo...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  if (error) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogContent>
          <Alert severity="error">
            <Typography variant="h6">Error al cargar el recibo</Typography>
            <Typography variant="body2">{error}</Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <ReciboDetalleView
      open={open}
      onClose={onClose}
      data={finalData}
      mode={mode}
      valorMaximoRedondeo={valorMaximoRedondeo}
      clienteData={clienteData}
      onConfirm={handleSubmit}
      formatCurrency={formatCurrency}
      formatDate={formatDate}
      formatNumeroRecibo={formatNumeroRecibo}
    />
  );
};

export default ReciboDetalleContainer;
